/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Ship_Title4Inputs */

const en_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store submission`)
};

const ar_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقديم المتجر`)
};

const bn_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্টোর সাবমিশন`)
};

const de_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store-Übermittlung`)
};

const es_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envío de tienda`)
};

const fr_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission du magasin`)
};

const pt_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envio da loja`)
};

const zh_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商店提交`)
};

const tr_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza gönderimi`)
};

const ru_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправка в магазин`)
};

const pl_svc_mobile_app_development_ship_title4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przesyłanie do sklepu`)
};

/**
* | output |
* | --- |
* | "Store submission" |
*
* @param {Svc_Mobile_App_Development_Ship_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_ship_title4 = /** @type {((inputs?: Svc_Mobile_App_Development_Ship_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Ship_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "de") return de_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "es") return es_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_ship_title4(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_ship_title4(inputs)
	return en_svc_mobile_app_development_ship_title4(inputs)
});
export { svc_mobile_app_development_ship_title4 as "svc_mobile-app-development_SHIP_title" }